<template>
  <Panel :visible.sync="visible" @close="close">
    <div class="cloud-enterprise-auth">
      <div class="popup-title">云企业签约</div>
      <div class="popup-text">请您使用微信/易隆创APP扫描以下二维码，完成云企业签约</div>
      <div class="scan-qrcode">
        <img class="scan-qrcode-icon" src="@/assets/img/components/popup/CloudEnterpriseAuth/scan_qrcode_icon.png" alt="">
        <span>请扫码</span>
      </div>
      <img class="qr-code" src="@/assets/img/qrcode/cloud_enterprise_auth.jpg" alt="">
    </div>
  </Panel>
</template>

<script>
import Panel from './Panel.vue'

export default {
  components: { Panel },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    close() {
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.cloud-enterprise-auth {
  width: 640px;
  height: 450px;
  background-image: url('@/assets/img/components/popup/CloudEnterpriseAuth/background.png');
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .popup-title {
    padding-top: 40px;
    font-family: @font-medium;
    font-size: 22px;
    color: #d0700e;
  }

  .popup-text {
    margin-top: 49px;
    font-size: 18px;
  }

  .scan-qrcode {
    margin-top: 33px;
    font-size: 14px;
    display: flex;
    align-items: center;

    .scan-qrcode-icon {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }

  .qr-code {
    width: 164px;
    height: 164px;
    margin-top: 14px;
    box-shadow: 0 4px 6px 0 rgba(169, 141, 123, 0.15);
  }
}
</style>
